import collective from "./Collective";
import comparison from "./Comparison";
import manual from "./Manual";
import dynamic from "./Dynamic";

export default {
  comparison,
  manual,
  collective,
  dynamic,
};
